import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

import { mapBorderTooltipStyles } from './mapBorderTooltip.styles';

const OFFSET_X = 20;
const OFFSET_Y = -2;

interface Position {
  left: string | null;
  top: string | null;
}

const MapBorderTooltip: React.FC = () => {
  const [position, setPosition] = useState<Position>({ left: null, top: null });

  const handleMouseMove = useCallback((e: MouseEvent) => {
    // Check if there's a higher z-index element at the cursor position
    const elementAtPoint = document.elementFromPoint(e.clientX, e.clientY);

    // If there's a popup element at the cursor position, don't show tooltip
    if (
      elementAtPoint &&
      (elementAtPoint.closest('.map-popup-container') || elementAtPoint.closest('.map-popup-bubble'))
    ) {
      setPosition({
        left: null,
        top: null,
      });
      return;
    }

    setPosition({
      left: e.pageX + OFFSET_X + 'px',
      top: e.pageY + OFFSET_Y + 'px',
    });
  }, []);

  useEffect(() => {
    document.body.addEventListener('mousemove', handleMouseMove, false);

    return () => {
      document.body.removeEventListener('mousemove', handleMouseMove, false);
    };
  }, [handleMouseMove]);

  const { left, top } = position;

  if (!left || !top) {
    return null;
  }

  return (
    <div
      className={mapBorderTooltipStyles}
      style={{
        left,
        top,
      }}
    >
      Click to see more
    </div>
  );
};

export default MapBorderTooltip;
